import RecordPayment from "./RecordPayment";

/** /super_admin/contribution/record_contribution[/:categoryId]: record payments for a member. */
const Record_ContributionMain = () => <RecordPayment />;

export default Record_ContributionMain;
